import GivewayListItem from '../GivewayListItem/GivewayListItem'
import styles from './GivewayList.module.css'

const GivewayList = () => {
    return (
        <div className={styles.container}>
            <div className={styles.listHead}>
                Доступные розыгрыши
            </div>
            <div className={styles.listContainer}>
                <GivewayListItem type='Премиум' icon={'https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39'}
                    name={'mega spin'} progress={110} allProgress={10000} btnText='Участвовать' />
                <GivewayListItem type='Премиум' icon={'https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39'}
                    name={'mega spin'} progress={5000} allProgress={10000} btnText='Участвовать' />
                <GivewayListItem type='Премиум' icon={'https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39'}
                    name={'mega spin'} progress={110} allProgress={10000} btnText='Участвовать' />
                <GivewayListItem type='Премиум' icon={'https://telegram.org/file/400780400440/3/tT1re8_uckY.28682.png/004617f1849e49bc39'}
                    name={'mega spin'} progress={110} allProgress={10000} btnText='Участвовать' />
            </div>
        </div>
    )
}

export default GivewayList